import React, { useEffect, useRef } from 'react';
import { Outlet, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import CompanyScopeSelector from './CompanyScopeSelector';

export default function MainLayout() {
  const { isAuthenticated, loading, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasRedirected = useRef(false);

  useEffect(() => {
    // Only redirect once after initial login, not on every route change
    if (!loading && isAuthenticated && user && !hasRedirected.current) {
      // Redirect employees to their dashboard only if they land on /dashboard
      if (user.role === 'employee' && location.pathname === '/dashboard') {
        hasRedirected.current = true;
        navigate('/employee/dashboard', { replace: true });
      }
    }
  }, [loading, isAuthenticated, user, location.pathname, navigate]);

  // Separate effect for blocking employee routes for non-employees
  useEffect(() => {
    if (!loading && isAuthenticated && user) {
      if (user.role !== 'employee' && location.pathname.startsWith('/employee/')) {
        navigate('/dashboard', { replace: true });
      }
    }
  }, [loading, isAuthenticated, user, location.pathname, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="text-slate-500">Chargement...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen bg-slate-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="h-14 bg-white border-b border-slate-200 flex items-center justify-end px-6 gap-3 shrink-0">
          <CompanyScopeSelector />
        </header>
        <main className="flex-1 overflow-y-auto p-6 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}